export default [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/home/layouts/HomeWrapper.vue"),
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/home/Home.vue"),
      },
      {
        path: "/rates",
        name: "Rate",
        props: true,
        component: () => import("@/views/home/HomeRates.vue"),
      },
      {
        path: "/transporter",
        name: "Transporter",
        component: () => import("@/views/home/Transporter.vue"),
        meta: { src: require("@/assets/erp.jpg") },
      },
      {
        path: "/shipper",
        name: "Shipper",
        component: () => import("@/views/home/Shipper.vue"),
        meta: { src: require("@/assets/market.jpg") },
      },
      {
        path: "/pricing",
        name: "Pricing",
        component: () => import("@/views/home/pricing/Index.vue"),
        meta: { src: require("@/assets/market.jpg") },
      },
      {
        path: "/about",
        name: "About",
        component: () => import("@/views/home/about/Index.vue"),
        meta: { src: require("@/assets/aboutus.jpg") },
      },
      {
        path: "/reach-us",
        name: "Reach Us",
        component: () => import("@/views/home/contact-us/Index.vue"),
        meta: { src: require("@/assets/contact_bg.jpg") },
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/auth/Login.vue"),
      },
      {
        path: "/forgetpassword",
        name: "Sign up",
        component: () => import("@/views/auth/ForgetPassword.vue"),
      },
      {
        path: "/privacy",
        name: "Privacy",
        component: () => import("@/views/privacy/Privacy.vue"),
      },
      {
        path: "/help",
        name: "Help",
        component: () => import("@/views/help/Help.vue"),
      },
      {
        path: "/signup",
        name: "Sign up",
        component: () => import("@/views/auth/Login.vue"),
      },
      {
        path: "/blogs",
        name: "Blogs",
        component: () => import("@/views/home/Blogs.vue"),
      },
      {
        path: "/b/:link",
        name: "Blog",
        component: () => import("@/views/home/page/BlogPage.vue"),
      },
    ],
  },
];
